// @core/api/endpoints/task/log_entity_time.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LogEntityTimeRequest,
  TimeEntryResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Log entity time
 * Records time spent on any task-aware entity with optional description and billing information.
 */
export async function LogEntityTime(
  target_type: string,
  target_id: string,
  data: LogEntityTimeRequest,
  options?: RequestOptions
): Promise<TimeEntryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:target_type/:target_id/time`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<TimeEntryResponse>(requestPath, data, requestOptions);
}
